import { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';

import {
    ReportParameterContainer,
    Subtitle,
    Line,
    SearchContainer,
    InputContainer,
    SearchButtonsContainer
} from './styles';
import FilterIcon from '../../assets/filter_icon.png';
import ModalCancel from '../Modal/Cancel';
import ModalWarn from '../Modal/Warn/index';
import { today } from '../../utils';

export default function ReportInputDataIntervalAgencyUnit(props) {
    const [modalCancel, setModalCancel] = useState(false);
    const { handleSubmit } = useForm();

    const [organOptions, setOrganOptions] = useState([]);
    const [unidadeOptions, setUnidadeOptions] = useState([]);
        
    const user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        async function loadOrganOptions() {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': user ? user.token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_usuario: user ? user.cpf_atendente : ""
                }),
            };
            
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/consultaOrgaoGestorOrgao`, requestOptions).then(
                function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        var organList = [];
                        data.map((organ) => (organList.push({ value: organ.CODIGO_ORGAO, label: organ.NOME_REDE_ATENDIMENTO })));
                        setOrganOptions(organList);
                    });
                } else {
                    //Exception here
                }
            }).catch(function(err) {
                //Exception here
            });
        }

        loadOrganOptions();
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function loadUnidadeOptions(data) {
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                codigo_orgao: data.value
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/listaUnidadesPorOrgao`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data) {

                    var unidadesList = [];
                    var obj = {};

                    data.forEach((unidade) => {
                        obj = {
                            value: unidade.CODIGO_UNIDADE,
                            label: unidade.NOME_UNIDADE
                        }

                        unidadesList.push(obj);
                    });

                    setUnidadeOptions(unidadesList);
                });
            } else {
                console.log('Error request to /gestao/listaUnidadesPorOrgao');
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    return (
        <>
            <ReportParameterContainer>
                <ModalCancel
                    id="modalcancelalert"
                    appear={modalCancel}
                    text={"Deseja retornar para a página anterior?"}
                    actionButton1={() => setModalCancel(false)}
                    actionButton2={() => props.history.push("/pesquisarcidadao")}
                />
                <ModalWarn
                    id="modalconfirmalert"
                    appear={props.modalError}
                    text={props.messageError}
                    textButton2='Ok'
                    actionButton2={() => props.setModalError(false)}
                />
                <Subtitle>
                    <img
                        src={FilterIcon}
                        alt="filterIcon"
                    />
                    <label> Período </label>
                    <Line />
                </Subtitle>
                <form onSubmit={handleSubmit(() => props.onSubmitSearch())}>
                    <SearchContainer>
                        <InputContainer>
                            <div className="br-input">
                                <label htmlFor="dt_inicio">Data de início</label>
                                <input
                                    id="dateandtime-input"
                                    name="dt_inicio"
                                    type="date"
                                    data-input="data-input"
                                    placeholder="dd/mm/aaaa"
                                    value={props.dataInterval.dt_inicio}
                                    onChange={e => { props.setDataInterval({ ...props.dataInterval, dt_inicio: e.target.value }); props.setResult() }}

                                />
                            </div>
                        </InputContainer>
                        <InputContainer>
                            <div className="br-input">
                                <label htmlFor="dt_inicio">Data final</label>
                                <input
                                    id="dateandtime-input"
                                    name="dt_fim"
                                    type="date"
                                    data-input="data-input"
                                    placeholder="dd/mm/aaaa"
                                    value={props.dataInterval.dt_fim}
                                    onChange={e => { props.setDataInterval({ ...props.dataInterval, dt_fim: e.target.value }); props.setResult() }}
                                />
                            </div>
                        </InputContainer>
                        <InputContainer>
                            <label htmlFor="organ">Rede de atendimento</label>
                            <select
                                className="br-select"
                                style={{ width: '100%', borderRadius: '6px', border: '1px solid #888' }}
                                name="organ"
                                id="organ"
                                value={props.selectedAgency?.value}
                                required={props.selectedAgency?.value !== ""}
                                onChange={e => { 
                                    const selectedOption = organOptions.find(option => option.value === e.target.value) || { value: "", label: "Todos" };
                                    props.setSelectedAgency(selectedOption); 
                                    props.setDataInterval({ ...props.dataInterval, organ: e.target.value });
                                    props.setResult();
                                    loadUnidadeOptions(selectedOption);
                                }}
                            >
                                <option value="">Todos</option>
                                {organOptions && organOptions.length > 0 && 
                                    organOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))
                                }
                            </select>
                        </InputContainer>
                        <InputContainer>
                            <label htmlFor="unit">Unidade</label>
                            <select
                                className="br-select"
                                style={{ width: '100%', borderRadius: '6px', border: '1px solid #888' }}
                                name="unit"
                                id="unit"
                                disabled={props.selectedAgency?.value === ""}
                                value={props.selectedUnit?.value}
                                required={props.selectedUnit?.value !== ""}
                                onChange={e => { 
                                    const selectedOption = unidadeOptions.find(option => option.value === e.target.value) || { value: "", label: "Todas" };
                                    props.setSelectedUnit(selectedOption); 
                                    props.setDataInterval({ ...props.dataInterval, organ: e.target.value });
                                    props.setResult();
                                }}
                            >
                                <option value="">Todas</option>
                                {unidadeOptions && unidadeOptions.length > 0 && 
                                    unidadeOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))
                                }
                            </select>
                        </InputContainer>
                    </SearchContainer>
                    <SearchButtonsContainer>
                        <button className="br-button terciary" type="button"
                            onClick={() => setModalCancel(true)}>
                            Voltar
                        </button>
                        <button className="br-button secondary" type="button"
                            onClick={() => {props.setDataInterval({ ...props.dataInterval, dt_inicio: "", dt_fim: today() }); props.setSelectedAgency({ value: "", label: "Todos" }); props.setSelectedUnit({ value: "", label: "Todas" }); props.setResult(undefined)}}>
                            Limpar filtros
                        </button>
                        <button className="br-button terciary" type="button" disabled={!(props.result && Object.entries(props.result).length > 0)}
                            onClick={() => window.print()}>
                            Imprimir
                        </button>
                        <button className={props.loadingReport ? "br-button primary loading" : "br-button primary"} type="submit">
                            Gerar relatório
                        </button>
                    </SearchButtonsContainer>

                    <Subtitle>
                        <Line />
                    </Subtitle>
                </form>
            </ReportParameterContainer>
        </>
    );
}